/**
 * Tauro 10x (PT-5962): registering under a campaign whose cookie carries enabled
 * factorisation rules requires an explicit Tauro 10X Account Rules acceptance,
 * mirroring the Add Account flow (PT-5955). Partner (affiliate/IB) registrations
 * never open factorised accounts, so they are exempt.
 */
export const requiresTauroTermsOnRegistration = (
  tauroFactorisation: unknown,
  isAffiliate: boolean,
): boolean => Boolean(tauroFactorisation) && !isAffiliate
